import { CreditCard, ExternalLink, Loader2, AlertCircle, Shield } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useBilling } from "@/providers/BillingProvider";

export function BillingTab() {
  const { manageBilling, isProcessing, error } = useBilling();

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-3 p-4 bg-muted/30 rounded-lg border border-border">
        <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center shrink-0">
          <Shield className="h-5 w-5 text-primary" />
        </div>
        <div>
          <p className="text-sm font-medium">Secure Billing</p>
          <p className="text-xs text-muted-foreground">
            Your billing details are securely managed by Stripe. We never store
            your payment information on our servers.
          </p>
        </div>
      </div>

      <div className="border border-border rounded-lg p-4">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center">
            <CreditCard className="h-5 w-5 text-primary" />
          </div>
          <div>
            <p className="font-medium text-sm">Payment Methods & Invoices</p>
            <p className="text-xs text-muted-foreground">
              Manage your payment methods, view invoices, and update billing
              information
            </p>
          </div>
        </div>

        {error && (
          <div className="flex items-center gap-2 p-3 mb-4 rounded-lg bg-destructive/10 border border-destructive/20 text-destructive text-sm">
            <AlertCircle className="h-4 w-4 shrink-0" />
            <span>{error}</span>
          </div>
        )}

        <Button
          onClick={manageBilling}
          disabled={isProcessing}
          className="w-full"
        >
          {isProcessing ? (
            <>
              <Loader2 className="h-4 w-4 mr-2 animate-spin" />
              Opening Stripe...
            </>
          ) : (
            <>
              Manage Billing
              <ExternalLink className="h-4 w-4 ml-2" />
            </>
          )}
        </Button>
      </div>

      <p className="text-xs text-center text-muted-foreground">
        You will be redirected to Stripe's secure billing portal
      </p>
    </div>
  );
}
